import { Link, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import useAuthStore from '@/store/authStore';
import Sidebar from './Sidebar/Sidebar';
import CampaignBanner from '@/components/ui/CampaignBanner';
import styles from './AppLayout.module.css';

/** Aviso fixo pro personal bloqueado por inadimplência (treinos suspensos). */
function BillingBlockedBanner() {
  const { t } = useTranslation();
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '12px 16px',
        marginBottom: 'var(--space-4)',
        borderRadius: 'var(--radius-md)',
        border: '1px solid color-mix(in srgb, var(--danger) 40%, transparent)',
        background: 'color-mix(in srgb, var(--danger) 10%, transparent)',
        color: 'var(--hi)',
        fontSize: 13.5,
      }}
    >
      <AlertTriangle size={18} strokeWidth={2} color="var(--danger)" style={{ flex: 'none' }} />
      <span style={{ flex: 1 }}>{t('invoices.blockedBanner')}</span>
      <Link to="/trainer/invoices" style={{ color: 'var(--danger)', fontWeight: 600, whiteSpace: 'nowrap' }}>
        {t('invoices.blockedBannerCta')}
      </Link>
    </div>
  );
}

export default function AppLayout() {
  const user = useAuthStore((s) => s.user);

  return (
    <div className={styles.shell}>
      <Sidebar role={user?.role} />
      <div className={styles.main}>
        <main className={styles.content}>
          {user?.role === 'trainer' && user?.billingBlockedAt && <BillingBlockedBanner />}
          <CampaignBanner />
          <Outlet />
        </main>
      </div>
    </div>
  );
}
